import intl from 'react-intl-universal'

export default ['$window', 'fnService', '$rootScope', kickerAdminController]

const emptyLabelEntry = {
  text: '',
  url: '',
  display: true,
}

// TODO presently individula labels are updated via angula 2 way binding
// and array references, making this more truly a stateful component.
// sever this via deep copy and manage all updates via sync() (and throttle it too)

// const throttler = (fn, delay = 100) => {
//   let t
//   return (...args) => { // 0...n arguments for fn
//     window.clearTimeout(t)
//     t = window.setTimeout(fn, delay, ...args)
//     return t
//   }
// }

/* Variables Atlas
  vm.labelsCfg - loaded labels config, ostensibly in the latest rev B format
  vm.kickerTypes - all keys in vm.labelsCfg.types
  vm.activeKey - key for the current labelType being edited
  vm.activeType - the object the key indicates
*/

function kickerAdminController($window, _fn, $rootScope) {
  var vm = this
  vm.intl = intl

  const sync = () => {
    // todo: throttle
    if (vm.setLabels) {
      vm.setLabels(vm.labelsCfg)
    }
  }

  vm.switchType = () => {
    vm.activeKey = vm.activeKey || vm.kickerTypes[0]
    vm.activeType = vm.labelsCfg.types[vm.activeKey]
  }

  vm.updateLabels = () => {
    vm.kickerTypes = Object.keys(vm.labelsCfg.types)
    vm.switchType()
  }

  vm.remove = (i) => {
    vm.activeType.labels.splice(i, 1)
    sync()
  }

  vm.addNew = (i = 0) => {
    vm.activeType.labels.splice(i, 0, Object.assign({}, emptyLabelEntry))
    sync()
  }

  vm.addType = () => {
    let newType = $window.prompt(intl.get('settings.kicker.addPrompt'))
    newType = _fn.stringToPropName(newType)
    if (newType && !vm.labelsCfg.types[newType]) {
      vm.labelsCfg.types[newType] = { labels: [], isFreeEntry: false }
      vm.activeKey = newType
      vm.updateLabels()
    }
  }

  vm.removeType = () => {
    if (vm.activeKey) {
      delete vm.labelsCfg.types[vm.activeKey]
      vm.updateLabels()
    }
  }

  vm.$onChanges = (deltas) => {
    if (deltas.labelsCfg && vm.getLabels) {
      // if the change affected or set labelsCfg
      vm.labelsCfg = vm.getLabels() // get copy from model
      vm.updateLabels() // propogate changes to UI, and to model
      vm.ready = true // which is ready now, if not before
    }
  }

  vm.$onInit = () => {
    vm.ready = false
  }

  $rootScope.$on('BEFORE_SAVE_SETTINGS', (e) => {
    sync()
  })
}
